export default __webpack_public_path__ + "static/media/icon_briefcase.04974643.svg";